<template>
  <Teleport to="body">
    <div v-if="current" class="confirm-overlay" @click.self="handleCancel">
      <div :class="['confirm-card', { 'confirm-card-wide': current.wide }]">
        <p v-if="!current.html" class="confirm-msg">{{ current.message }}</p>
        <div
          v-else
          class="confirm-msg confirm-msg-html"
          v-html="current.message"
        ></div>
        <input
          v-if="current.type === 'prompt'"
          v-model="inputValue"
          type="password"
          class="confirm-input"
          @keyup.enter="handleOk"
        />
        <div class="confirm-btns">
          <button
            v-if="current.type !== 'alert'"
            class="btn-cancel"
            @click="handleCancel"
          >
            取消
          </button>
          <button class="btn-ok" @click="handleOk">确定</button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { ref, computed } from "vue";

const queue = ref([]);
const inputValue = ref("");

const current = computed(() => queue.value[0] || null);

function enqueue(dialog) {
  return new Promise((resolve) => {
    queue.value.push({ ...dialog, resolve });
  });
}

function dequeue() {
  queue.value.shift();
  inputValue.value = "";
}

function handleOk() {
  if (!current.value) return;
  const { type, resolve } = current.value;
  dequeue();
  if (type === "prompt") {
    resolve(inputValue.value || "");
  } else {
    resolve(true);
  }
}

function handleCancel() {
  if (!current.value) return;
  const { type, resolve } = current.value;
  dequeue();
  if (type === "prompt") {
    resolve(null);
  } else {
    resolve(false);
  }
}

function confirm(message, opts) {
  const html = opts?.html || false;
  const wide = opts?.wide || false;
  return enqueue({ type: "confirm", message, html, wide });
}

function alert(message) {
  return enqueue({ type: "alert", message });
}

function prompt(message, defaultValue) {
  inputValue.value = defaultValue || "";
  return enqueue({ type: "prompt", message });
}

defineExpose({ confirm, alert, prompt });
</script>

<style scoped>
.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10001;
}
.confirm-card {
  background: #fff;
  border-radius: 8px;
  padding: 28px 32px 20px;
  min-width: 360px;
  max-width: 480px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.confirm-card-wide {
  min-width: 600px;
  max-width: 1050px;
  max-height: 88vh;
  padding: 28px 36px 20px;
}
.confirm-msg {
  font-size: 15px;
  color: #1f2937;
  line-height: 1.6;
  margin: 0 0 18px;
  white-space: pre-wrap;
}
.confirm-msg-html {
  white-space: normal;
  flex: 1;
  overflow-y: auto;
}
.confirm-input {
  display: block;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  margin-bottom: 18px;
  outline: none;
}
.confirm-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}
.confirm-btns {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.btn-ok {
  padding: 8px 22px;
  background: #3b82f6;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.btn-ok:hover {
  background: #2563eb;
}
.btn-cancel {
  padding: 8px 22px;
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.btn-cancel:hover {
  background: #e5e7eb;
}
</style>
